module.exports = __webpack_public_path__ + "static/media/car-pink.ca852dd3.svg";